import React from 'react';
import * as PropTypes from 'prop-types';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import useCalendarStyles from '../availabilities/hooks/useCalendarStyles';
import Day from './Day';

const abbrvWeeknames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function Month({ calendar, onWeekDayClick, children, admin = true, selectedCalendarDay, setSelectedCalendarDay, setDate, navigations, setAvailabilities }) {
  const { Button } = useUiContext();
  const { daysOfMonth, weekDayNames, monthName, month, year } = calendar;

  const AdminMonthView = () => {
    const { classes } = useCalendarStyles();

    return (
      <div className="monthlyview">
        <span className={classes.calendarColumnHeaderMonth}>{monthName} {year}</span>
        <GridList cellHeight={40} cols={14}>
          {weekDayNames.map((weekDay) => (
            <GridListTile key={weekDay} cols={2} className={classes.dayNameTile}>
              <span className={classes.calendarColumnHeaderDay}>{weekDay}</span>
            </GridListTile>
          ))}
        </GridList>
        <GridList cellHeight={160} cols={14} className={classes.gridListWrapper}>
          {daysOfMonth.map((day) => (
            <GridListTile key={`list-${day.date}`} cols={2} className={classes.calendarTile}>
              <Day
                key={`day-${day.date}`}
                day={day}
                type="Month"
                onWeekDayClick={onWeekDayClick}
                offset={monthName !== day.monthName}
                displaySideHours={false}
                admin={admin}
              >
                {/* eslint-disable-next-line no-shadow */}
                {(day) => children(day)}
              </Day>
            </GridListTile>
          ))}
        </GridList>
      </div>
    );
  };

  const handleSliderClick = (newDate) => () => {
    setDate(newDate);
    setSelectedCalendarDay(null);
    setAvailabilities(null);
  };

  const ClientMonthView = () => {
    const { previous, next } = navigations;
    const currentDatetime = new Date();
    const fullCalendarDate = `${month}/${year}`;
    const fullCurrentDate = `${(currentDatetime.getMonth() + 1)}/${currentDatetime.getFullYear()}`;
    let pastDate = false;

    return (
      <div className="client-monthly-view">
        <div className="calendar-btn-wrapper">
          <Button
            id="previous_calendar_arrow"
            onClick={handleSliderClick(previous)}
            disabled={!previous}
            style={{ visibility: (fullCalendarDate !== fullCurrentDate) ? 'visible' : 'hidden' }}
          >
            <ArrowBackIosIcon fontSize="small" />
          </Button>
          <h2>{monthName}</h2>
          <Button id="next_calendar_arrow" onClick={handleSliderClick(next)} disabled={!next}>
            <ArrowForwardIosIcon />
          </Button>
        </div>
        <div className="client-calendar-box">
          <ul>
            {abbrvWeeknames.map((weekDay) => (
              <GridListTile key={weekDay} cols={2}>
                <span className="calendar-header">{weekDay}</span>
              </GridListTile>
            ))}
            {daysOfMonth.map((day) => {
              if (day.monthName !== monthName) {
                return <GridListTile key={`list-${day.date}`} cols={2} />;
              }

              pastDate = false;
              if ((day.dayOfWeek < currentDatetime.getDate()) && (fullCalendarDate === fullCurrentDate)) {
                pastDate = true;
              }

              return (
                <GridListTile key={`list-${day.date}`} cols={2}>
                  <Day
                    key={`day-${day.date}`}
                    day={day}
                    type="Month"
                    onWeekDayClick={onWeekDayClick}
                    offset={monthName !== day.monthName}
                    displaySideHours={false}
                    admin={admin}
                    selectedCalendarDay={selectedCalendarDay}
                    setSelectedCalendarDay={setSelectedCalendarDay}
                    pastDate={pastDate}
                  >
                    {/* eslint-disable-next-line no-shadow */}
                    {(day) => children(day)}
                  </Day>
                </GridListTile>
              );
            })}
          </ul>
        </div>
      </div>
    );
  };

  return admin ? <AdminMonthView /> : <ClientMonthView />;
}

Month.defaultProps = {
  onWeekDayClick: null,
};

Month.propTypes = {
  calendar: PropTypes.object.isRequired,
  onWeekDayClick: PropTypes.func,
};

export default Month;
